import React from 'react'
import styled from 'styled-components'
import Pdfcontain from '../../../service/components/Pdfcontain'
import ProjectHeader from './ProjectHeader'
import { STEP } from '../projectStepManager'

function DevView(props) {
    var nums = props.nums
    var viewContract = props.viewContract
    var exdata = props.exdata || {}
    var imageSrc = props.imageSrc
    var offerOks = props.offerOks
    var pg = props.pg
    var displayStep = props.displayStep
    var admin = props.admin
    var my = props.my

    var list = ''
    var type = ''
    var canApprove = false
    var hasReport = false

    if (nums === 5) {
        hasReport = !!(viewContract && viewContract.develop1)
        list = hasReport ? viewContract.develop1 : my ? '' : exdata.develop1
        type = 'develop1Upload'
        canApprove = !admin
    } else if (nums === 6) {
        hasReport = !!(viewContract && viewContract.develop2)
        list = hasReport ? viewContract.develop2 : my ? '' : exdata.develop2
        type = 'develop2Upload'
        canApprove = !admin
    } else if (nums === 7) {
        hasReport = !!(viewContract && viewContract.develop3)
        list = hasReport ? viewContract.develop3 : my ? '' : exdata.develop3
        type = 'develop3Upload'
        canApprove = !admin
    }

    var headerTitle =
        nums === 5
            ? displayStep === STEP.DEV1
                ? '1단계 개발'
                : displayStep === STEP.DEV1_RECEIVE
                ? '1단계 보고서 수신'
                : displayStep === STEP.DEV1_APPROVE
                ? '1단계 보고서 승인'
                : '1단계 개발 보고서'
            : nums === 6
            ? displayStep === STEP.DEV2
                ? '2단계 개발'
                : displayStep === STEP.DEV2_RECEIVE
                ? '2단계 보고서 수신'
                : displayStep === STEP.DEV2_APPROVE
                ? '2단계 보고서 승인'
                : '2단계 개발 보고서'
            : displayStep === STEP.FINAL_REPORT
            ? '3단계 개발'
            : displayStep === STEP.FINAL_REPORT_RECEIVE
            ? '3단계 보고서 수신'
            : displayStep === STEP.FINAL_REPORT_APPROVE
            ? '3단계 보고서 승인'
            : '3단계 개발 보고서'

    return (
        <ViewRoot>
            {!props.hideHeader ? <ProjectHeader pg={pg} viewTitle={headerTitle} /> : ''}

            <TopSection>
                {my && !hasReport ? null : (
                    <Pdfcontain
                        top={false}
                        list={list}
                        single={true}
                        type={type}
                        types="only"
                        num={nums}
                        mini={true}
                        file={imageSrc && imageSrc.base64 ? imageSrc.base64 : ''}
                        agree={canApprove}
                        nums={nums}
                        data={viewContract}
                        onClick={offerOks}
                    />
                )}
            </TopSection>
        </ViewRoot>
    )
}

export default DevView

const ViewRoot = styled.div`
    width: 100%;
`

const TopSection = styled.div`
    margin-top: 0;
`
